/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider-carousel-normail.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Setting - Carousel Slider - デフォルト
 */
function carouselSlider() {
  const option = {
    freeMode: true,
    effect: 'fade',
    loop: true,
    slidesPerView: 1,
    // spaceBetween: 10,
    allowTouchMove: true, // タッチ操作を有効にする
    speed: 100,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
  };

  // Swiperの初期化
  const sliderCarousel = new Swiper(".slider-carousel", option);
}

// ページ読み込み後に関数を呼び出す
document.addEventListener('DOMContentLoaded', function() {
  carouselSlider();
});


 export { carouselSlider };